<template>
    <v-app v-if="form_success">
        <v-main>
            <div>
                <div class="text-center">
                    <v-icon size="150" class="rounded-circle" icon="mdi-check" color="info"/>
                    <h2 class="font-weight-light">We received your quote request!</h2>
                    <p class="ma-auto mt-5 mb-5">We're working hard to find the best price for your business and will send you a detailed quote as soon as we can.</p>
                </div>
            </div>
        </v-main>
        <div class="d-flex">
            <v-spacer/>
            <v-btn variant="tonal" :color="ConfigElementsColor" rounded="pill" @click="OpenReviewForm" prepend-icon="mdi-pencil-circle-outline">Write a review</v-btn>
            <div class="ma-2"></div>
            <v-btn variant="tonal" :color="ConfigElementsColor" rounded="pill" @click="Reload" prepend-icon="mdi-plus-circle-outline">Create a new Quote</v-btn>
            <v-spacer/>
        </div>
    </v-app>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useGlobalsStore } from '@/stores/globals'

const store = useGlobalsStore()
const { form_success, ConfigElementsColor } = storeToRefs(store)
const { SetAnyState } = store

function Reload() {
  location.reload()
}

function OpenReviewForm() {
  SetAnyState({
    target: 'cart_modal',
    value: false,
  })
  SetAnyState({
    target: 'form_modal',
    value: false,
  })
  SetAnyState({
    target: 'review_modal',
    value: true,
  })
}
</script>
